import { API_AUTH } from "./common";

const XoaHopDongApi = {
  xoaHopDong: ({ chovayId }) =>
    API_AUTH.post(`quan-ly-cho-vay/xoa-cam-do?chovayId=${chovayId}`, {}),
  kiemTraXoaHopDong: ({ chovayId }) =>
    API_AUTH.post(
      `quan-ly-cho-vay/kiem-tra-xoa-cam-do?chovayId=${chovayId}`,
      {},
    ),
  kiemTraXoaHopDongKySo: ({ chovayId }) =>
    API_AUTH.post(
      `quan-ly-cho-vay/kiem-tra-xoa-hop-dong-ky-so?chovayId=${chovayId}`,
      {},
    ),
};

export default XoaHopDongApi;
